let refreshPromise: Promise<void> | null = null;

export interface RefreshConfig {
  refreshUrl: string;
}

let config: RefreshConfig | null = null;

export function configureTokenRefresh(cfg: RefreshConfig): void {
  config = cfg;
}

export async function refreshToken(): Promise<void> {
  if (refreshPromise) return refreshPromise;
  if (!config) throw new Error("tokenRefresh not configured");

  refreshPromise = (async () => {
    const response = await fetch(config!.refreshUrl, {
      method: "POST",
      credentials: "include",
    });
    if (!response.ok) throw new Error("Refresh failed");
  })().finally(() => {
    refreshPromise = null;
  });

  return refreshPromise;
}
